import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { reloadWhenCacheClearedElsewhere, resetFirestoreCacheOnce } from "./firebase";

const rootElement = document.getElementById("root")!;
const root = ReactDOM.createRoot(rootElement);

const renderApp = () => {
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
};

// Bezpečnost (a): odhlášení nebo jednorázové vymazání po nasazení v jiné
// záložce vymazalo cache Firestore a tím ukončilo Firestore i v této
// záložce – načíst znovu (firebase.ts).
reloadWhenCacheClearedElsewhere();

// Jednorázové vymazání cache Firestore po nasazení verze (a) – musí proběhnout
// před prvním čtením (vykreslení App); na vykreslení se čeká nejvýš ~1 s.
resetFirestoreCacheOnce().then(renderApp, renderApp);

// Service worker zůstává odregistrovaný (viz plán redesignu – PWA cache je
// samostatný projekt); úklid starých registrací ve WebView ponecháváme.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    for (let reg of regs) {
      reg.unregister();
    }
  });
}

serviceWorkerRegistration.unregister();
